import actions from '@/store/integrator/moduleIntegratorActions.js'

export default {
  namespaced: true,
  actions,
}
